import React from 'react'
import { Trash2 } from 'lucide-react'
import store from '../../../../../../state/store'

class PendingTutorProposalsPartial extends React.Component {

  onRemove = () => {
    store.emit('pending_tutor_proposals:remove_tutor', this.props.tutor.id)
  }

  render() {
    return (
      <div className="flex w-full items-start gap-2 py-2 first:pt-0 last:pb-0">
        <img className="block size-10 shrink-0 rounded-full" src={this.props.tutor.profile_picture_url} alt="Mug shot"/>
        <div className="flex-1">
          <p className="font-semibold">{this.props.tutor.name}</p>
          <p className="text-sm capitalize text-muted-foreground">{this.props.tutoring_job_position_names}</p>
        </div>
        <span className="ml-auto cursor-pointer text-muted-foreground hover:text-destructive" onClick={this.onRemove}><Trash2 className="size-4"/></span>
      </div>
    )
  }
}

export default PendingTutorProposalsPartial
